module.exports = __webpack_public_path__ + "catalog/items/stairs/L-shaped-stairs-with-landing/L-shaped-stairs-with-landing-icon.svg";